module.exports = __webpack_public_path__ + "static/bnr_wide@2x-06c95fe46c3706f2bc2c8ba63b3cbe80.webp";